import React, { createContext, PropsWithChildren, useContext } from 'react';

import { GlobalAppCollection } from 'models/app';
import { useFetchAppCollectionsQuery } from '../../../redux/api/appMarket-api-slice';
import { AppCollectionScenarios } from '../../../models/enums';

export type CollectionsContextType = {
  collections: GlobalAppCollection[];
  isLoading: boolean;
};

const defaultValues: CollectionsContextType = {
  collections: [],
  isLoading: false,
};

export const CollectionsContext = createContext<CollectionsContextType>(defaultValues);
CollectionsContext.displayName = 'CollectionsContext';

export const useAppCollections = () : CollectionsContextType => useContext(CollectionsContext);

export const CollectionsContextProvider : React.FC<PropsWithChildren<{}>> = (props : PropsWithChildren<{}>) : JSX.Element => {
  const { children } = props;

  const { data : appCollections, isLoading } = useFetchAppCollectionsQuery({scenario:AppCollectionScenarios.AppMarket});

  const value: CollectionsContextType = !isLoading && appCollections && appCollections.entities && appCollections.ids
      ? { collections : Object.values(appCollections.entities) as GlobalAppCollection[], isLoading }
      : { collections : [], isLoading : true };

  return (
    <CollectionsContext.Provider value={value}>
      {children}
    </CollectionsContext.Provider>
  );
};
